import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenEn = () => {
    return <AddStartpageComToYourHomeScreen languageCode="en" />
}

export default AddStartpageComToYourHomeScreenEn
